import React, { useState, useEffect, useRef } from "react"

import img01 from "../assets/img/flatart_ai_studio_header_01.webp"
import img02 from "../assets/img/flatart_ai_studio_header_02.webp"
import img03 from "../assets/img/flatart_ai_studio_header_03.webp"
import img04 from "../assets/img/flatart_ai_studio_header_04.webp"
import img05 from "../assets/img/flatart_ai_studio_header_05.webp"

const AiCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)
  const [screenSize, setScreenSize] = useState("desktop")
  const autoPlayRef = useRef(null)
  const touchStartX = useRef(0)
  const touchEndX = useRef(0)

  const images = [img01, img02, img03, img04, img05]

  const updateCarousel = (newIndex) => {
    if (isAnimating) return
    setIsAnimating(true)
    setCurrentIndex((newIndex + images.length) % images.length)
    setTimeout(() => setIsAnimating(false), 800)
  }

  const startAutoPlay = () => {
    if (autoPlayRef.current) clearInterval(autoPlayRef.current)
    autoPlayRef.current = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length)
    }, 5000)
  }

  const stopAutoPlay = () => {
    if (autoPlayRef.current) {
      clearInterval(autoPlayRef.current)
      autoPlayRef.current = null
    }
  }

  const handleCardClick = (index) => {
    if (isAnimating || index === currentIndex) return
    stopAutoPlay()
    updateCarousel(index)
    setTimeout(startAutoPlay, 3000)
  }

  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].screenX
    stopAutoPlay()
  }

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].screenX
    const diff = touchStartX.current - touchEndX.current
    if (Math.abs(diff) > 50) {
      updateCarousel(diff > 0 ? currentIndex + 1 : currentIndex - 1)
    }
    setTimeout(startAutoPlay, 3000)
  }

  const getTransform = (offset) => {
    if (screenSize === "mobile") {
      if (offset === 0) return "scale(1.05) translateZ(0)"
      if (offset === 1) return "translateX(60px) scale(0.85) translateZ(-50px) rotateY(-5deg)"
      if (offset === images.length - 1) return "translateX(-60px) scale(0.85) translateZ(-50px) rotateY(5deg)"
      return "scale(0.7) translateZ(-200px)"
    }
    if (screenSize === "tablet") {
      if (offset === 0) return "scale(1.1) translateZ(0)"
      if (offset === 1) return "translateX(80px) scale(0.9) translateZ(-50px) rotateY(-6deg)"
      if (offset === 2) return "translateX(160px) scale(0.75) translateZ(-200px) rotateY(-12deg)"
      if (offset === images.length - 1) return "translateX(-80px) scale(0.9) translateZ(-50px) rotateY(6deg)"
      if (offset === images.length - 2) return "translateX(-160px) scale(0.75) translateZ(-200px) rotateY(12deg)"
      return "scale(0.7) translateZ(-200px)"
    }
    // desktop
    if (offset === 0) return "scale(1.15) translateZ(0)"
    if (offset === 1) return "translateX(200px) scale(0.95) translateZ(-50px) rotateY(-8deg)"
    if (offset === 2) return "translateX(400px) scale(0.8) translateZ(-200px) rotateY(-15deg)"
    if (offset === images.length - 1) return "translateX(-200px) scale(0.95) translateZ(-50px) rotateY(8deg)"
    if (offset === images.length - 2) return "translateX(-400px) scale(0.8) translateZ(-200px) rotateY(15deg)"
    return "scale(0.8) translateZ(-200px)"
  }

  const getCardStyle = (index) => {
    const offset = (index - currentIndex + images.length) % images.length
    const base = {
      transition: "all 0.8s cubic-bezier(0.68, -0.6, 0.32, 1.6)",
      transform: getTransform(offset),
    }
    if (offset === 0) return { ...base, zIndex: 10, opacity: 1 }
    if (offset === 1 || offset === images.length - 1) return { ...base, zIndex: 5, opacity: 0.8 }
    if (offset === 2 || offset === images.length - 2) return { ...base, zIndex: 1, opacity: 0.6 }
    return { opacity: 0, pointerEvents: "none" }
  }

  useEffect(() => {
    startAutoPlay()
    const updateSize = () => {
      const w = window.innerWidth
      setScreenSize(w <= 480 ? "mobile" : w <= 768 ? "tablet" : "desktop")
    }
    updateSize()
    window.addEventListener("resize", updateSize)
    return () => {
      stopAutoPlay()
      window.removeEventListener("resize", updateSize)
    }
  }, [])

  return (
    <div className="carousel-container ai">
      <div
        className="carousel-track"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {images.map((image, index) => {
          const offset = (index - currentIndex + images.length) % images.length
          return (
            <div
              key={index}
              className="card ai"
              style={getCardStyle(index)}
              onClick={() => handleCardClick(index)}
            >
              <img
                className="card-img"
                src={image}
                alt={`AI Studio ${index + 1}`}
                style={offset === 0 ? { filter: "none" } : {}}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AiCarousel
